import { handleActions } from 'redux-actions';
import { reduxKey } from './constants';
import { GiftingStoreSlice, UserGiftInitStatus } from './types';
import {
  initGiftState,
  initGiftStateFailure,
  initGiftStateSuccess,
} from './actions';

const reducers = handleActions<GiftingStoreSlice, any>(
  {
    [initGiftState.toString()]: (
      state,
      action: ReturnType<typeof initGiftState>
    ) => {
      return {
        ...state,
        [action.payload.user.useridUuid]: {
          initStatus: UserGiftInitStatus.Loading,
        },
      };
    },
    [initGiftStateSuccess.toString()]: (
      state,
      action: ReturnType<typeof initGiftStateSuccess>
    ) => {
      const {
        user,
        canBeGivenLlama = state[user.useridUuid]?.canBeGivenLlama,
        canBeGivenCake = state[user.useridUuid]?.canBeGivenCake,
        canBeGivenCore = state[user.useridUuid]?.canBeGivenCore,
      } = action.payload;

      return {
        ...state,
        [user.useridUuid]: {
          canBeGivenLlama,
          canBeGivenCake,
          canBeGivenCore,
          initStatus: UserGiftInitStatus.Initialized,
        },
      };
    },
    [initGiftStateFailure.toString()]: (
      state,
      action: ReturnType<typeof initGiftStateFailure>
    ) => {
      const useridUuid = action.payload.user.useridUuid;
      return {
        ...state,
        [useridUuid]: {
          ...(state[useridUuid] ?? {}),
          initStatus: UserGiftInitStatus.FailedToInitialize,
        },
      };
    },
  },
  {}
);

export default {
  [reduxKey]: reducers,
};
